import React, { useContext } from 'react';
import FirebaseContext from '../../context/firebase.context';
import Map from '../../components/LeafletMap/Map';
import Footer from '../../components/footer';
import {
  TermosDeUso, NovoCadastro, CadastrosAtivosAdmin,
  PoliticaDEProvacidade, Suporte, MeusDados, CadastrosAtivos,
  CadastrosInativosAdmin,
  NotificarUsuario,
  AtribuirNovo,
  AdicionarExpetador,
} from '../../components/modals';
import Loader from '../../assets/loader.gif';
import './dashboard.scss';

function Dashboard() {
  const { VerificaLogin, logado } = useContext(FirebaseContext);
  VerificaLogin('confirmacao');

  return (
    <>
      {logado
        ? (
          <>
            <PoliticaDEProvacidade aceite={{ show: false }} />
            <TermosDeUso aceite={{ show: false }} />
            <NovoCadastro aceite={{ show: false }} />
            <Suporte />
            <MeusDados />
            <AdicionarExpetador />
            <CadastrosAtivos />
            <CadastrosAtivosAdmin />
            <AtribuirNovo />
            <CadastrosInativosAdmin />
            <NotificarUsuario />
            <Map />
            <Footer />
          </>
        )
        : (
          <div id="loader-initial">
            <img src={Loader} alt="Carregando" />
            <span>Carregando seu perfil, por favor aguarde...</span>
          </div>
        )}
    </>
  );
}

export default Dashboard;
